import React, { useEffect, useState } from "react";
import styles from "./CustomCursor.module.css";
import { motion, useMotionValue, useSpring } from "framer-motion";

function CustomCursor() {
    const [visible, setVisible] = useState(false);

    const x = useMotionValue(0);
    const y = useMotionValue(0);
    const springX = useSpring(x, { stiffness: 300, damping: 30 });
    const springY = useSpring(y, { stiffness: 300, damping: 30 });
    const mouseRef = React.useRef({ x: 0, y: 0 });
    
    useEffect(() => {
        const handleMouseMove = (e) => {
            x.set(e.clientX);
            y.set(e.clientY);

            mouseRef.current = { x: e.clientX, y: e.clientY };

            const hoveredEl = document.elementFromPoint(e.clientX, e.clientY);
            const isInteractive = hoveredEl?.closest("[data-cursor='true']");
            setVisible(Boolean(isInteractive));
            document.body.style.cursor = isInteractive ? "none" : "default";
        };

        const handleScroll = () => {
            const { x: mx, y: my } = mouseRef.current;
            const hoveredEl = document.elementFromPoint(mx, my);
            const isInteractive = hoveredEl?.closest("[data-cursor='true']");
            setVisible(Boolean(isInteractive));
            document.body.style.cursor = isInteractive ? "none" : "default";
        };

        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("scroll", handleScroll);
            document.body.style.cursor = "default"; // reset on unmount
        };

    }, [x, y]);


    return (
        <motion.div
            className={`${styles.cursor} ${visible ? styles.visible : ""}`}
            style={{ 
                x: springX,
                y: springY,
                position: "fixed",
                top: 0,
                left: 0,
                width: 0,
                height: 0,
                pointerEvents: "none",
                transform: undefined /* remove inline transform to rely on CSS */
            }}
        >
            <span className={styles.label}>View</span>
        </motion.div>
    );

}

export default CustomCursor;
